import { BASE_URL } from '../constants/SystemConstants';


// export const BASE_URL = BASE_URL;
export const LOGIN_URL = BASE_URL + 'auth';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';

